import { Fragment } from "react";
import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";

import Button from "../../common/button/components/Button";
import useStores from "../../../hooks/useStores";
import {
  CorrectorBox,
  CorrectorSubtitle,
  CorrectorTitle,
  CorrectorWrapper,
  LeftImage,
  RightImage,
  StyledGrid,
  Subtitle,
  Title,
  WrapperLeft,
  WrapperRight,
} from "../styles/HomeStyles";

const Home = observer(() => {
  const location = useLocation();
  const { correctorAndProducerStore } = useStores();

  const { loading, correctorData, productorData } = correctorAndProducerStore;

  const searchParams = new URLSearchParams(location.search);
  const corretoraParam = searchParams.get("corretora");
  const corretorParam = searchParams.get("corretor");

  const hasCustomCorrector = Boolean(
    correctorData && correctorData.corretor_nome !== "SULAMERICA"
  );

  const buildPfParams = () => {
    const params = new URLSearchParams();

    if (corretoraParam) {
      params.set("corretora", corretoraParam);
    }

    if (corretorParam) {
      params.set("corretor", corretorParam);
    }

    const query = params.toString();
    return query ? `?${query}` : "";
  };

  const buildPmeParams = () => {
    if (
      !hasCustomCorrector ||
      !correctorData?.ev ||
      !correctorData?.ea ||
      !correctorData?.aa
    ) {
      return "";
    }

    const params = new URLSearchParams({
      ev: String(correctorData.ev),
      ea: String(correctorData.ea),
      aa: String(correctorData.aa),
    });

    if (productorData?.produtor_nome) {
      params.set("np", productorData.produtor_nome);
    }

    if (productorData?.produtor_email) {
      params.set("ep", productorData.produtor_email);
    }

    return `?${params.toString()}`;
  };

  const pfUrl = `${import.meta.env.VITE_PF_URL}${buildPfParams()}`;
  const pmeUrl = `${import.meta.env.VITE_PME_URL}${buildPmeParams()}`;

  const displayedName =
    productorData?.produtor_nome ?? correctorData?.corretor_nome ?? "";

  const displayedPhone =
    productorData?.produtor_telefone ??
    correctorData?.corretor_telefone ??
    "";

  return (
    <Fragment>
      <Grid
        container
        alignItems="center"
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <StyledGrid size={{ xs: 12, md: 6 }}>
          <LeftImage />
          <WrapperLeft>
            <Title>Odonto Individual</Title>
            <Subtitle sx={{ margin: "20px 50px" }}>
              Planos para você cuidar da sua saúde bucal com os melhores
              profissionais e clínicas do Brasil
            </Subtitle>
            <Button
              component="a"
              href={pfUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              background="fill"
              bgcolor="#FF6710"
              width="min(100%, 400px)"
              disabled={loading}
              $slim
            >
              {loading ? "carregando" : "contrate agora"}
            </Button>
          </WrapperLeft>
        </StyledGrid>

        <StyledGrid size={{ xs: 12, md: 6 }}>
          <RightImage />
          <WrapperRight>
            <Title>Odonto PME</Title>
            <Subtitle>
              Planos empresariais, de 2 a 29 vidas, com o melhor
              custo-benefício.
            </Subtitle>
            <Button
              component="a"
              href={pmeUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              background="fill"
              bgcolor="#162A6B"
              width="min(100%, 400px)"
              disabled={loading}
              $slim
            >
              {loading ? "carregando" : "contrate agora"}
            </Button>
          </WrapperRight>
        </StyledGrid>
      </Grid>

      {hasCustomCorrector && (
        <CorrectorBox>
          <Grid container>
            <Grid size={6} display="flex" justifyContent="flex-end">
              <CorrectorWrapper>
                <CorrectorTitle>Corretor:</CorrectorTitle>
                <CorrectorSubtitle>{displayedName}</CorrectorSubtitle>
              </CorrectorWrapper>
            </Grid>
            <Grid size={6}>
              <CorrectorWrapper>
                <CorrectorTitle>Contato:</CorrectorTitle>
                <CorrectorSubtitle>{displayedPhone}</CorrectorSubtitle>
              </CorrectorWrapper>
            </Grid>
          </Grid>
        </CorrectorBox>
      )}
    </Fragment>
  );
});

export default Home;
